import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox", "selectAllCheckbox", "bulkActions", "selectedCount", "deleteButton"]

    connect() {
        this.updateUI()
    }

    toggleAll(event) {
        this.checkboxTargets.forEach(checkbox => {
            checkbox.checked = event.target.checked
        })
        this.updateUI()
    }

    toggleOne() {
        this.selectAllCheckboxTarget.checked = this.checkboxTargets.every(checkbox => checkbox.checked)
        this.selectAllCheckboxTarget.indeterminate =
            this.checkboxTargets.some(checkbox => checkbox.checked) &&
            !this.checkboxTargets.every(checkbox => checkbox.checked)

        this.updateUI()
    }

    updateUI() {
        const selectedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length

        // Update count display
        this.selectedCountTarget.textContent = selectedCount

        // Show/Hide bulk actions toolbar
        if (selectedCount > 0) {
            this.bulkActionsTarget.classList.remove("d-none")
        } else {
            this.bulkActionsTarget.classList.add("d-none")
        }

        // Update form inputs for the delete button
        this.updateDeleteForm(selectedCount)
    }

    updateDeleteForm(selectedCount) {
        const form = this.deleteButtonTarget.closest("form")
        if (!form) return

        // Remove existing hidden inputs for IDs
        form.querySelectorAll("input[name='entity_ids[]']").forEach(input => input.remove())

        if (selectedCount > 0) {
            this.checkboxTargets.filter(c => c.checked).forEach(checkbox => {
                const input = document.createElement("input")
                input.type = "hidden"
                input.name = "entity_ids[]"
                input.value = checkbox.value
                form.appendChild(input)
            })
        }
    }
}
